import abattoir from './images/abattoir-side.png';
import adriana from './images/adriana.png';
import genavieve from './images/genavieve.png';
import glass from './images/glass.png';
import josephine from './images/josephine.png';
import susanna from './images/susanna.png';
import museum from './images/final_hazy.jpg';

export const imageGridIntroData = [
	{
		title: 'Art and Digital Media',
		text: 'Digital and fine art made with Adobe Creative Suite and traditional mediums like pen and ink, oil paint, graphite, and watercolor.',
		link: '/art-digital-media',
		button: 'View art and media',
		image1: abattoir,
		altText1: 'Insert alt text.',
		image2: josephine,
		altText2: 'Insert alt text.',
		image3: adriana,
		altText3: 'Insert alt text.',
		image4: glass,
		altText4: 'Insert alt text.',
		image5: genavieve,
		altText5: 'Insert alt text.',
		image6: susanna,
		altText6: 'Insert alt text.',
		image7: museum,
		altText7: 'Insert alt text.',
	},


]